import { useContext } from 'react';

import ArrivalNotice from '@/components/ArrivalNotice';
import CadModel from '@/components/CadModel';
import CouponDialog from '@/components/CouponDialog';
import { CompareModal } from '@/components/ProductItem/components/compareAndCollect';
import QuotedPrice from '@/components/QuotedPrice';
import { LayoutContext } from '@/layouts/baseLayout/provider';
import { ProductListProvider } from '@/providers/productList';
import useProductStore from '@/store/product';
import Utils from '@/utils/Utils';

export default function ProductList({ children, ...props }) {
  const { onlySScreen } = useContext(LayoutContext);
  const {
    compareData,
    updateCompareData,
    couponData,
    updateCouponData,
    arrivalNoticeData,
    updateArrivalNoticeData,
    quotedPriceData,
    updateQuotedPriceData,
    datasheetData,
    updateDatasheetData,
  } = useProductStore();

  // 关闭优惠券侧边栏
  function closeCouponModal() {
    updateCouponData({
      ...couponData,
      open: false,
    });
  }
  // 关闭比较商品弹窗
  function closeCompareModal() {
    updateCompareData({
      ...compareData,
      open: false,
    });
  }
  // 关闭到货通知弹窗
  function closeArrivalNoticeModal() {
    updateArrivalNoticeData({
      ...arrivalNoticeData,
      open: false,
    });
  }
  // 关闭报价弹窗
  function closeQuotePriceModal() {
    updateQuotedPriceData({
      ...quotedPriceData,
      open: false,
    });
  }
  // 关闭数据手册
  function closeDatasheetModal() {
    updateDatasheetData({
      ...datasheetData,
      open: false,
    });
  }

  return (
    <ProductListProvider {...props}>
      {children?.length > 0 ? (
        <>
          {props?.searchResult?.productRecordList?.length > 0 && (
            <div id="lcxh" className="rounded-t-[10px] bg-[white] px-[20px]">
              <ul className="flex border-b-[1px] border-solid border-b-[#F1F2F4] pb-[13px] pt-[11px] font-bold">
                <li className="w-[121px]"></li>
                <li className={Utils.addBigScreenClassName('w-[178px]', '_lg:w-[215px]', onlySScreen)}>
                  <h2 className="text-[#333]">型号/品牌/封装/类目</h2>
                </li>
                <li className={Utils.addBigScreenClassName('w-[190px]', '_lg:w-[233px]', onlySScreen)}>
                  <h2 className="text-[#333]">参数/描述</h2>
                </li>
                <li className={Utils.addBigScreenClassName('w-[157px]', '_lg:w-[180px]', onlySScreen)}>
                  <h2 className="text-[#333]">优惠券/标签</h2>
                </li>
                <li className="flex-1 text-center">
                  <h2 className="text-[#333]">价格梯度(含税)</h2>
                </li>
                <li className={Utils.addBigScreenClassName('w-[161px]', '_lg:w-[186px]', onlySScreen)}>
                  <h2 className="text-[#333]">库存交期</h2>
                </li>
                <li className={`${Utils.addBigScreenClassName('w-[120px]', '_lg:w-[140px]', onlySScreen)} text-center`}>
                  <h2 className="text-[#333]">操作</h2>
                </li>
              </ul>
            </div>
          )}
          <>{children}</>
        </>
      ) : (
        <></>
      )}
      <CouponDialog open={couponData?.open} product={couponData?.product} onClose={() => closeCouponModal()} />
      <CompareModal
        className={Utils.addBigScreenClassName('', '_lg:-ml-[110px]', onlySScreen)}
        open={compareData?.open}
        index={compareData?.index}
        productVO={compareData?.productVO}
        rs_log={compareData?.rs_log}
        onCancel={() => closeCompareModal()}
      />
      <ArrivalNotice
        open={arrivalNoticeData?.open}
        product={arrivalNoticeData?.product}
        onCancel={() => closeArrivalNoticeModal()}
      />
      <QuotedPrice
        open={quotedPriceData?.open}
        product={quotedPriceData?.product}
        onCancel={() => closeQuotePriceModal()}
      />
      {datasheetData?.open && (
        <CadModel open={datasheetData?.open} product={datasheetData?.product} onCancel={() => closeDatasheetModal()} />
      )}
    </ProductListProvider>
  );
}
